import { getMockPolicies } from "../builders/getMockPolicies";
import { MockPolicyId } from "../mockPolicies";
import { testDriveMember } from "../mockMembers";

import { MockPersona } from "./mockPersonas.types";

const usPolicies: MockPolicyId[] = ["abc123"];
const canadianPolicies: MockPolicyId[] = ["dc101"];

export const jonHomeless: MockPersona = {
  key: "jonHomeless",
  name: "Jon Homeless",
  description: "🇺🇸/🇨🇦 | No address or phone | One core policy in each country | No HDC | 2 E-sign Alerts",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: getMockPolicies(...usPolicies),
        canada: getMockPolicies(...canadianPolicies),
      },
    },
    esign: {
      fetchESignDocuments: [
        { Id: 101, StateRegion: "MD" },
        { Id: 102, StateRegion: "QC" },
      ],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "jon@homeless.com",
            firstName: "Jon",
            middleName: "",
            lastName: "Homeless",
            mailingAddress: {
              line1: "",
              line2: "",
              city: "",
              state: "",
              postalCode: "",
              country: "CANADA",
            },
            preferredPhone: "",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000015",
                source: "USA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
              {
                customerAccountLegacyKey: "000016",
                source: "CANADA",
                customerSourceSystemKey: "123",
                id: "2",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: testDriveMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 1,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: undefined,
    },
  },
};
